import {
    GET_CHOICEQUESTIONDATA,
    GET_HOTQUESTIONDATA
    
} from './mutation_types.js'
export default {
    //获取 精选问题 存入vuex
	[GET_CHOICEQUESTIONDATA](state, data) {	  
        state.choiceData = data;	
	}, 
    //获取 热门问题 存入vuex
	[GET_HOTQUESTIONDATA](state, data) {	  
        state.hotData = data;	
	}, 
  
}